import React from 'react';
import './App.css';
import ComparisonForm from "./components/ComparisonForm";


export const App = () => <div className="jsa-demo">
  <ComparisonForm/>
</div>;
